export default "__VITE_ASSET__CQ8gh0SK__"